import { Modal } from 'antd'
import { formatDate } from 'common/services/format'
import type { ESignFormStatusItem } from 'features/Procedure/state/procedure-api.type'
import styles from './e-sign-log-modal.module.scss'

type Props = {
  isVisible: boolean
  onClose: () => void
  signedData: ESignFormStatusItem | null
}

export const ESignLogModal = ({ isVisible, onClose, signedData }: Props) => {
  if (!signedData || !signedData.items || signedData.items.length === 0) return null

  const latestSign = signedData.items[0]

  const signerName = `${latestSign.fname || ''} ${latestSign.lname || ''}`.trim() || 'Unknown'
  const formattedDate = formatDate(latestSign.datetime, {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  })

  return (
    <Modal
      closeIcon={null}
      classNames={{ content: styles.modalContent }}
      open={isVisible}
      onCancel={onClose}
      title={null}
      destroyOnHidden
      footer={null}>
      <div className={styles.container}>
        <h2 className={styles.title}>eSign Log</h2>
        <p className={styles.signedInfo}>
          <span className={styles.signedLabel}>eSigned</span> by{' '}
          <span className={styles.signerName}>{signerName}</span> on {formattedDate}
        </p>
        {latestSign.amendment && (
          <p className={styles.amendment}>
            <span className={styles.amendmentLabel}>Amendment:</span> {latestSign.amendment}
          </p>
        )}
      </div>
    </Modal>
  )
}
